import React, { useMemo } from 'react';
import { string, bool, func, number } from 'prop-types';
import * as styles from './styles/styles.module.scss';

import ProBadge from '../../../../assets/images/icons/pro-badge-white-bg.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CircleButton = ({ icon, large, onClick, title, className, rotation, print }) => {
  const style = useMemo(() => {
    return {
      backgroundImage: `url(${icon}`,
      transition: 'transform .4s ease-in-out',
      transform: `rotate(${rotation}deg)`
    };
  }, [rotation]);

  return (
    <button
      type="button"
      className={`${large ? styles.largeButton : styles.smallButton} ${className}`}
      aria-label={title}
      onClick={onClick}
      title={title}
      style={style}
    >
      {print && <img alt={StringConstantsMixin.strings.PRO.ALLTRAILS_PRO} className={styles.proBadge} src={ProBadge} />}
    </button>
  );
};

export default CircleButton;

CircleButton.propTypes = {
  icon: string.isRequired,
  large: bool,
  onClick: func.isRequired,
  title: string.isRequired,
  className: string,
  rotation: number
};

CircleButton.defaultProps = {
  large: false,
  className: '',
  rotation: 0
};
